import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import axios from 'axios';

import styled from 'styled-components';


import { getSelectedProductIdd, getWhich_is, setSelectedProductIdd, setWhich_is  ,getSelectedCategoryIdd,setSelectedCategoryIdd      } from './globalState';






import PromoImageSlider from './PromoImageSlider'; 
import PromoImageSliderFeast from './PromoImageSliderFeast'; 



import PromoVideoSlider from './PromoVideoSlider'; 
import LoginPopup from './LoginPopup.js'; 
import Feast from './Feast.js'; 
import FeastBar from './FeastBar.js'; 
import ProductImageDisplay from './ProductImageDisplay'; 



















const PLACEHOLDER_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';






  



  
  <ProductImageDisplay/>
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  

  
  
/*


const ProductImageDisplay = React.memo(function ({ productId, fetchProductImage, onProductImageClick }) {
  const [image, setImage] = useState(null);
  const [imageLoading, setImageLoading] = useState(true);

  useEffect(() => {
    const fetchImage = async () => {
      setImageLoading(true);
      const images = await fetchProductImage(productId, 'low-res');
      if (Array.isArray(images) && images.length > 0) {
        const img = images[0];
        const imageType = img.imageType ? img.imageType.toLowerCase() : '';
        if (['jpeg', 'jpg', 'png', 'image/jpeg', 'image/png'].includes(imageType)) {
          setImage(img);
        } else {
          setImage(null);
        }
      } else {
        setImage(null);
      }
      setImageLoading(false);
    };

    fetchImage();
  }, [productId, fetchProductImage]);

  if (imageLoading) {
    return <p style={{ ...styles.productDescription, textAlign: 'center' }}>Loading image...</p>;
  }

  if (!image) {
    return (
      <div style={styles.productImageWrapper}>
        <img
          src={PLACEHOLDER_IMAGE}
          alt={`Product ${productId}`}
          style={{
            
            height: 'auto',
              width:'100%',
            objectFit: 'cover',
            borderRadius: '8px',
            cursor: 'pointer',
          }}
          onClick={() => {
            onProductImageClick(productId);
            const targetDiv = document.getElementById('target-div');
            if (targetDiv) {
              targetDiv.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });
            }
          }}
        />
        <p style={{ ...styles.productDescription, marginTop: '5px' }}>
          Image not available or unsupported format.
        </p>
      </div>
    );
  }

  const imageUrl = `data:${image.imageType.toLowerCase()};base64,${image.imageData}`;

  return (
    <div style={styles.productImageWrapper}>
      <img
        src={imageUrl}
        alt={`Product ${productId}`}
        style={{
          height: 'auto',
          width: '60%',
          objectFit: 'cover',
          borderRadius: '8px',
          cursor: 'pointer',
        }}
        onClick={() => {
          onProductImageClick(productId);
          const targetDiv = document.getElementById('target-div');
          if (targetDiv) {
            targetDiv.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        }}
      />
    </div>
  );
});

*/
  const ProductSearch = (        ) => {























    
const feastRef = useRef();
 const [isLoading, setIsLoading] = useState(false);
  const cartRef = useRef(null); // Ref for cart div



  const [selectedProduct, setSelectedProduct] = useState(null);



  const [selectedProductId, setSelectedProductId] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [rawProducts, setRawProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [subcategories, setSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState('');
  const [sets, setSets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [cart, setCart] = useState([]);
  const [showCart, setShowCart] = useState(false);
  const [salesId, setSalesId] = useState('');
  const [showMenu, setShowMenu] = useState(false);
  const [showMenuC, setShowMenuC] = useState(false);
  const [showMenuCC, setShowMenuCC] = useState(false);

  const [hoveredSet, setHoveredSet] = useState(null);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [isSubcategoryMenuHovered, setIsSubcategoryMenuHovered] = useState(false);
  const [isCategoryMenuHovered, setIsCategoryMenuHovered] = useState(false);
  const [subcategoriesLoading, setSubcategoriesLoading] = useState(false);
  const [showImageDisplay, setShowImageDisplay] = useState(false);
  const [thumbnails, setThumbnails] = useState([]);
  const [highResImage, setHighResImage] = useState(null);
  const [imageLoading, setImageLoading] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const hoverTimeoutRef = useRef(null);
  const categoryHoverTimeoutRef = useRef(null);
  const setRefs = useRef({});
  const categoryRefs = useRef({});
  const setMenuRef = useRef(null);
  const categoryMenuRef = useRef(null);
  const imageCache = useRef(new Map());
  const imageRef = useRef(null);
  const containerRef = useRef(null);
  const products = useMemo(() => rawProducts, [rawProducts]);

const [whichIs, setWhichIs] = useState(getWhich_is());

const MenuContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  display: flex;
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;





  const [isMenuOpen, setIsMenuOpen] = useState(false);

 useEffect(() => {
    if (isMenuOpen) {
      // Freeze the page by disabling scroll
      document.body.style.overflow = 'hidden';
    } else {
      // Restore scroll when menu is closed
      document.body.style.overflow = 'auto';
    }
    // Cleanup on component unmount
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };


















const styles = {
  container: {
    padding: '20px',
    fontFamily: '"Lora", serif',
backgroundColor: whichIs === 0 ? '#355E3B' : '#C2B280',


    position: 'relative',
  },
  storeName: {
    backgroundColor: '#3C2F2F',
    color: '#F4C430',
    fontSize: '48px',
    fontWeight: 'bold',
    padding: '25px 50px',
    textAlign: 'center',
    letterSpacing: '4px',
    textTransform: 'uppercase',
    borderBottom: 'none',
    marginBottom: '0',


   fontFamily: whichIs === 0 ?        '"Impact", sans-serif'       :    '"Papyrus", sans-serif'           ,






  },
  storeTitle: {
    backgroundColor: '#8B5E3C',
    color: '#FFF',
    fontSize: '24px',
    fontWeight: 'normal',
    padding: '10px 20px',
    textAlign: 'center',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    marginTop: '0',



   fontFamily: whichIs === 0 ?        '"Jokerman", serif'       :    '"Bebas Neue", sans-serif'           ,



  },
 controls: {
      marginTop: '20px',
      display: 'flex', // Use Flexbox
      justifyContent: 'space-between', // Space between left and right groups
      alignItems: 'center', // Vertically align items
    },
    leftGroup: {
      display: 'flex', // Group left buttons
      gap: '10px', // Space between left buttons
    },
    rightGroup: {
      display: 'flex', // Group right buttons
      gap: '10px', // Space between right buttons
    },



  searchInput: {
    width: '100%',
    maxWidth: '400px',
    minWidth: '200px',
    padding: '12px 18px',
    fontSize: '16px',
    border: '1px solid #D4A373',
    borderRadius: '6px',
    backgroundColor: '#FFF',
    boxSizing: 'border-box',
    outline: 'none',
    color: '#3C2F2F',
    transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
    boxShadow: '0 0 6px rgba(212, 163, 115, 0.2)',
    fontFamily: '"Lora", serif',
  },
  browseButton: {
    padding: '12px 24px',




    backgroundColor: '#D4A373',
backgroundColor: whichIs === 0 ? '#D4A373' : '#5C4033',




    color: '#FFF',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: 'bold',
    transition: 'background-color 0.3s ease',
    fontFamily: '"Lora", serif',
  },
  menuContainer: {
    position: 'absolute',
    top: '180px',
    left: '20px',
    zIndex: 1000,
    display: 'flex',
  },

 


overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.4)', // dark background
    zIndex: 999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'auto',
  },

overlay1: {
  position: 'fixed',
  top: 0,
  left: '10vw', // centers it horizontally (100vw - 80vw) / 2
  width: '80vw',
  height: '100vh',
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
  zIndex: 999,
  overflowY: 'auto', // enables vertical scrolling
  display: 'flex',
  alignItems: 'flex-start', // optional: align content to top
  justifyContent: 'center',
  paddingTop: '40px', // optional padding from top
},



  menuContainerC: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    zIndex: 1000,
  },












  
  setMenu: {
    backgroundColor: '#FFF',
    border: '1px solid #D4A373',
    borderRadius: '6px',
    boxShadow: '0 4px 12px rgba(212, 163, 115, 0.15)',
    minWidth: '200px',
  },
  categoryMenu: {
    backgroundColor: '#FFF',
    border: '1px solid #D4A373',
    borderRadius: '6px',
    boxShadow: '0 4px 12px rgba(212, 163, 115, 0.15)',
    minWidth: '200px',
    position: 'relative',
    padding: '10px',
  },
  subcategoryMenu: {
    backgroundColor: '#FFF',
    border: '1px solid #D4A373',
    borderRadius: '6px',
    boxShadow: '0 4px 12px rgba(212, 163, 115, 0.15)',
    minWidth: '200px',
    padding: '15px',
  },
  menuItem: {
    padding: '10px 15px',
    fontSize: '1rem',
    color: '#3C2F2F',
    cursor: 'pointer',
    fontFamily: '"Lora", serif',
    transition: 'background-color 0.3s ease',
  },
  productList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: '25px',
    marginTop: '30px',
  },
  productCard: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '20px',
    border: '1px solid #E8D5B9',
    borderRadius: '10px',
    backgroundColor: '#FFF',
    boxShadow: '0 4px 12px rgba(212, 163, 115, 0.15)',
  },
  productImageWrapper: {
    flex: '0 0 160px',
    marginBottom: '15px',
    textAlign: 'center',
    borderRadius: '8px',
    position: 'relative',
    zIndex: 1,
  },
  productDetailsWrapper: {
    flex: '1',
    padding: '0 10px',
    textAlign: 'center',
  },
  productName: {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    color: '#3C2F2F',
    fontFamily: '"Playfair Display", serif',
    marginBottom: '10px',
    textTransform: 'capitalize',
  },
  productDescription: {
    fontSize: '1rem',
    color: '#6B4E31',
    fontFamily: '"Lora", serif',
    marginBottom: '10px',
    lineHeight: '1.6',
  },
  productStock: {
    fontSize: '1.1rem',
    color: '#8B5E3C',
    fontFamily: '"Lora", serif',
    marginBottom: '10px',
  },
  productPrice: {
    fontSize: '1.4rem',
    color: '#F4C430',
    fontWeight: 'bold',
    fontFamily: '"Playfair Display", serif',
    marginBottom: '12px',
  },
  addButton: {
    padding: '12px 24px',
    backgroundColor: '#8B5E3C',
    color: '#FFF',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: 'bold',
    transition: 'background-color 0.3s ease',
    fontFamily: '"Lora", serif',
  },
  cartButton: {
    padding: '12px 24px',
    backgroundColor: '#F4C430',
    color: '#3C2F2F',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '1rem',
    margin: '5px',
    fontFamily: '"Lora", serif',
  },
 cartButtonM: {
    padding: '12px 24px',
    backgroundColor: '#F4C430',
    color: '#3C2F2F',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '1rem',
    margin: '5px',
    fontFamily: '"Lora", serif',
  },






  cartDetails: {
    marginTop: '25px',
    padding: '25px',
    border: '1px solid #E8D5B9',
    borderRadius: '8px',
    backgroundColor: '#FFF',
    boxShadow: '0 4px 12px rgba(212, 163, 115, 0.15)',
  },
  cartItem: {
    marginBottom: '12px',
    fontSize: '1rem',
    color: '#3C2F2F',
    fontFamily: '"Lora", serif',
  },
  submitButton: {
    padding: '12px 24px',
    backgroundColor: '#D4A373',
    color: '#FFF',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: 'bold',
    transition: 'background-color 0.3s ease',
    fontFamily: '"Lora", serif',
  },
  imageDisplay: {
    display: 'flex',
    width: '100%',
    marginTop: '20px',
    padding: '20px',
    border: '1px solid #E8D5B9',
    borderRadius: '8px',
    backgroundColor: '#FFF',
    boxShadow: '0 4px 12px rgba(212, 163, 115, 0.15)',
    position: 'relative',
  },
  
  
  zoomArea: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    borderRadius: '8px',
    overflow: 'hidden',
    border: '1px solid #D4A373',
  },

  closeButton: {
    position: 'absolute',
    top: '20px',
    right: '20px',
    width: '30px',
    height: '30px',
    backgroundColor: '#8B5E3C',
    color: '#FFF',
    border: '1px solid #D4A373',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    fontWeight: 'bold',
    fontFamily: '"Lora", serif',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    zIndex: 15,
  },
  
  
  promoPercentage: {
    margin: 0,
    padding: '0.2em 0',
  },
  discountBox: {
    backgroundColor: '#28a745', // Green background
    color: '#ffffff', // White text
    padding: '2px 8px',
    borderRadius: '4px',
    fontSize: '14px',
    fontWeight: 'Arial',
    display: 'inline-block',
  },
  
  
cartIconButton: {
      padding: '12px',
      backgroundColor: '#F4C430',
      color: '#3C2F2F',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '1rem',
      margin: '5px',
      fontFamily: '"Lora", serif',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    cartIcon: {
      position: 'relative',
      display: 'inline-block',
    },
    cartIconSvg: {
      width: '24px',
      height: '24px',
    },
    cartCount: {
      position: 'absolute',
      top: '-8px',
      right: '-8px',
      backgroundColor: '#ff0000',
      color: 'white',
      borderRadius: '50%',
      width: '20px',
      height: '20px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '12px',
      fontWeight: 'bold',
    },

  
  

  
  
};





















  useEffect(() => {
    const interval = setInterval(() => {
      const value = getWhich_is();
      setWhichIs(prev => {
        if (prev !== value) return value;
        return prev;
      });
    }, 300); // check every 300ms

 return () => clearInterval(interval); // clean up on unmount
  }, []);
    


const handleSectionClick = (section) => {
    console.log('Clicked:', section);




  if(section==="PIZZAS"){
   fetchCategoriesBySet(14);

  setShowMenuC(true);



  }












  };

  const handleExternalToggle = () => {
    if (feastRef.current) {
      feastRef.current.toggleBar();
    }
    if(getWhich_is()===1    ){
setWhich_is(0); 




    }
else { 
  

  
  
  
  
  setWhich_is(1);  








    }



setRawProducts([]);
setSelectedProduct('');
setSelectedProductId('');
setSelectedProductIdd('');
setHighResImage('');


  };








  
  
  const axiosInstance = axios.create({
    baseURL: 'https://merseafeastandgroceries.co.uk:8443/api',
    
   // baseURL: 'https://localhost:8443/api',
    
  });

  const fetchProductImage = useCallback(
    async (productId, type, imageId = null) => {
      const cacheKey = `${productId}-${type}-${imageId || 'all'}`;
      if (imageCache.current.has(cacheKey)) {
        return imageCache.current.get(cacheKey);
      }

      try {
        const proid = Number(productId);
        let response;
        if (type === 'low-res') {
          response = await axiosInstance.get(`/productimages/${proid}/low-res-images`);
        } else if (type === 'high-res' && imageId) {
          response = await axiosInstance.get(`/productimages/image/${imageId}`);
        } else {
          throw new Error('Invalid image fetch type or missing imageId');
        }
        const data = response.data;
        if (type === 'low-res') {
          const filteredData = Array.isArray(data)
            ? data.filter((img) => {
                const imageType = img.imageType ? img.imageType.toLowerCase() : '';
                return ['jpeg', 'jpg', 'png', 'image/jpeg', 'image/png'].includes(imageType);
              })
            : [];
          imageCache.current.set(cacheKey, filteredData);
          return filteredData;
        } else {
          const imageType = data.imageType ? data.imageType.toLowerCase() : '';
          if (['jpeg', 'jpg', 'png', 'image/jpeg', 'image/png'].includes(imageType)) {
            imageCache.current.set(cacheKey, data);
            return data;
          }
          return null;
        }
      } catch (err) {
        console.error(`Error fetching ${type} product image:`, err);
        return type === 'low-res' ? [] : null;
      }
    },
    []
  );

    
const scrollToProductByKey = (selectedProductId1) => {
  if (!selectedProductId1) {
    console.warn('No product ID provided');
    return;
  }

  // Wait for DOM updates
  setTimeout(() => {
    const productDiv = document.getElementById(selectedProductId1);
    if (productDiv) {
      console.log('Element position:', productDiv.getBoundingClientRect());
      
      // Check if element is inside a scrollable container
      const parent = productDiv.closest('div[style*="overflow"]') || window;
      
      if (parent === window) {
        productDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        // Scroll within the container
        parent.scrollTo({
          top: productDiv.offsetTop - parent.offsetTop,
          behavior: 'smooth',
        });
      }
    } else {
      console.warn(`No div found with id: ${selectedProductId1}`);
    }
  }, 0);
};
    
    
    
    
    
    
    
    useEffect(() => {
  if (rawProducts && Array.isArray(rawProducts)) {
    const pr = rawProducts.find(p => p.productId === selectedProductId);
    if (pr) {
      setSelectedProduct(pr);
      // Optional: console.log(pr.title);
    }
  }
}, [rawProducts, selectedProductId]);

    
    
    
    
    
    
    
  const handleProductImageClick = useCallback(async (productId) => {

    setSelectedProductId(productId);

  setShowImageDisplay(true);
  setImageLoading(true);
  setHighResImage(null);

      
      
    const lowResImages = await fetchProductImage(productId, 'low-res');
    setThumbnails(Array.isArray(lowResImages) ? lowResImages : []);
    if (lowResImages.length > 0) {
      const highResData = await fetchProductImage(productId, 'high-res', lowResImages[0].imageId);
      setHighResImage(highResData);
    }
    setImageLoading(false);
    const targetDiv = document.getElementById('target-div');
    if (targetDiv) {
      targetDiv.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
    
    
    
     setShowMenu(false);
    
    
    
    
    
    
  }, [fetchProductImage]);

  useEffect(() => {
    if (showImageDisplay && containerRef.current) {
      const targetDiv = document.getElementById('target-div');
      if (targetDiv) {
        containerRef.current.scrollTo({
          top: targetDiv.offsetTop,
          behavior: 'smooth',
        });
      }
    }
  }, [showImageDisplay]);

  const handleThumbnailClick = useCallback(async (imageId) => {
    
    
    
    //if(highResImage===null)
    //setImageLoading(true);
    
    setIsLoading(true); 

    
    const highResData = await fetchProductImage(selectedProductId, 'high-res', imageId);
    setHighResImage(highResData);
    //setImageLoading(false);
  setIsLoading(false); 

    const targetDiv = document.getElementById('target-div');
    if (targetDiv) {
      targetDiv.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [selectedProductId, fetchProductImage]);

  const handleMouseMove = useCallback(
    (e) => {
      if (!isHovered || !imageRef.current) return;
      const rect = imageRef.current.getBoundingClientRect();
      const x = Math.min(Math.max(e.clientX - rect.left, 0), rect.width);
      const y = Math.min(Math.max(e.clientY - rect.top, 0), rect.height);
      setMousePos({ x, y });
    },
    [isHovered]
  );

  const calculateTotalBill = useCallback(() => {
    return cart.reduce((total, item) => total + item.fullCost * item.quantity, 0).toFixed(2);
  }, [cart]);

  const handleGenerateBill = useCallback(async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.get(`/reports/sales-bill`, {
        params: { salesId },
        responseType: 'blob',
      });

      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);

      const pdfWindow = window.open(pdfUrl, '_blank');
      if (pdfWindow) {
        pdfWindow.onload = () => {
          pdfWindow.print();
        };
      } else {
        alert('Please allow pop-ups for this site.');
      }
    } catch (error) {
      console.error('Error generating bill:', error);
      alert('Failed to generate bill.');
    }
  }, [salesId]);

  const fetchSets = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const response = await axiosInstance.get('/sets');
      if (Array.isArray(response.data)) {
        setSets(response.data);
      } else {
        console.error('Unexpected sets data format:', response.data);
        setError('Unexpected data format for sets.');
      }
    } catch (err) {
      console.error('Error fetching sets:', err);
      setError(`Error fetching sets: ${err.message}. Please check the backend server.`);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchCategoriesBySet = useCallback(async (setId) => {
    try {
      const response = await axiosInstance.get(`/categories/search_by_set_id?set_id=${setId}`);
      setCategories(response.data);
    } catch (err) {
      setError('Error fetching categories. Please try again later.');
      console.error('Error fetching categories:', err);
    }
  }, []);

  const fetchSubcategoriesByCategory = useCallback(async (categoryId) => {
    if (!categoryId || isNaN(categoryId)) {
      console.error('Invalid categoryId:', categoryId);
      setSubcategories([]);
      return;
    }
    setSubcategoriesLoading(true);
    try {
      const response = await axiosInstance.get(`/products/subcategories?categoryId=${categoryId}`);
      console.log(`Fetched subcategories for category ${categoryId}:`, response.data);
      if (!Array.isArray(response.data) || response.data.length === 0) {
        console.warn(`No subcategories found for category ${categoryId}`);
      }
      setSubcategories(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      setError('Error fetching subcategories. Please try again later.');
      console.error('Error fetching subcategories:', err);
      setSubcategories([]);
    } finally {
      setSubcategoriesLoading(false);
    }
  }, []);

  const fetchProducts = useCallback(async (keyword, categoryId, subcategoryId) => {
    setLoading(true);
    setError('');
    try {
      let response;
      if (keyword) {
        const params = new URLSearchParams({ name: keyword });
        response = await axiosInstance.get(`/products/search?${params.toString()}`);
      } else if (subcategoryId) {
        response = await axiosInstance.get(`/products?subcategoryId=${subcategoryId}`);
        console.log(`Fetched products for subcategory ${subcategoryId}:`, response.data);
      } else if (categoryId != null && !isNaN(categoryId) && Number.isFinite(Number(categoryId))) {
        response = await axiosInstance.get(`/products/search-by-category?categoryId=${categoryId}`);
      } else {
        setRawProducts([]);
        return;
      }
      setRawProducts(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      setError('Error fetching products. Please try again later.');
      console.error('Fetch products error:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSets();
  }, [fetchSets]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchKeyword) {
        fetchProducts(searchKeyword, null, null);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchKeyword, fetchProducts]);

  useEffect(() => {
    if (hoveredCategory) {
      fetchSubcategoriesByCategory(hoveredCategory);
    } else {
      setSubcategories([]);
    }
  }, [hoveredCategory, fetchSubcategoriesByCategory]);

  useEffect(() => {
    if (selectedSubcategory) {
      fetchProducts(null, null, selectedSubcategory);
    } else if (selectedCategory) {
      fetchProducts(null, selectedCategory, null);
    }
  }, [selectedSubcategory, selectedCategory, fetchProducts]);

  const handleSearchChange = useCallback((e) => {
    setSearchKeyword(e.target.value);
    setSelectedCategory('');
    setSelectedSubcategory('');
    setShowImageDisplay(false);
    setSelectedProductId(null);
    setThumbnails([]);
    setHighResImage(null);
  }, []);

  const handleAddToCart = useCallback((e, product) => {
    e.preventDefault();
    e.stopPropagation();
    setCart((prevCart) => {
      const existingProduct = prevCart.find((item) => item.productId === product.productId);
      if (existingProduct) {
        return prevCart.map((item) =>
          item.productId === product.productId
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      } else {
        return [...prevCart, { ...product, quantity: 1 }];
      }
    });
  }, []);

  const handleRemoveFromCart = useCallback((e, productId) => {
    e.preventDefault();
    e.stopPropagation();
    setCart((prevCart) => prevCart.filter((item) => item.productId !== productId));
  }, []);

  const handleIncreaseQuantity = useCallback((e, productId) => {
    e.preventDefault();
    e.stopPropagation();
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.productId === productId
          ? { ...item, quantity: item.quantity + 1 }
          : item
      )
    );
  }, []);

  const handleDecreaseQuantity = useCallback((e, productId) => {
    e.preventDefault();
    e.stopPropagation();
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.productId === productId && item.quantity > 1
          ? { ...item, quantity: item.quantity - 1 }
          : item
      )
    );
  }, []);

  // Fixed toggleCartVisibility function
    const toggleCartVisibility = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowCart((prevShowCart) => !prevShowCart);
  }, []);

 // Effect to handle scrolling when showCart changes to true
  useEffect(() => {
    if (showCart && cartRef.current) {
      console.log('Scrolling to cart div:', cartRef.current); // Debug log
      cartRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [showCart]);









  const submitSale = useCallback(async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const saleRequest = {
      customerId: 1,
      pay: calculateTotalBill(),
      discount: 0,
      products: cart.map((item) => ({
        productId: item.productId,
        unitCost: item.fullCost,
        quantity: item.quantity,
        discount: item.discount,
      })),
    };

    try {
      const response = await axiosInstance.post(`/sales/submit`, saleRequest);
      const salesId = response.data;
      setSalesId(salesId);
      alert('Sale submitted successfully!');
      await handleGenerateBill({ preventDefault: () => {} });
      setCart([]);
    } catch (err) {
      console.error('Error submitting sale:', err);
      alert('Error submitting sale. Please try again later.');
    }
  }, [cart, handleGenerateBill]);

  const handleMenuToggle = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowMenu((prev) => !prev);
    setHoveredSet(null);
    setHoveredCategory(null);
    setIsSubcategoryMenuHovered(false);
    setIsCategoryMenuHovered(false);
    setCategories([]);
    setSubcategories([]);
  }, []);

  const handleSetHover = useCallback((setId) => {
    if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
    hoverTimeoutRef.current = setTimeout(() => {
      setHoveredSet(setId);
      setHoveredCategory(null);
      setIsSubcategoryMenuHovered(false);
      setIsCategoryMenuHovered(false);
      if (setId) {
        fetchCategoriesBySet(setId);
      } else {
        setCategories([]);
        setSubcategories([]);
      }
    }, 300);
  }, [fetchCategoriesBySet]);

  const handleCategoryMenuHover = useCallback((isHovered) => {
    setIsCategoryMenuHovered(isHovered);
    if (!isHovered && !isSubcategoryMenuHovered) {
      if (categoryHoverTimeoutRef.current) clearTimeout(categoryHoverTimeoutRef.current);
      categoryHoverTimeoutRef.current = setTimeout(() => {
        if (!isSubcategoryMenuHovered) {
          setHoveredCategory(null);
          setSubcategories([]);
        }
      }, 3000);
    }
  }, [isSubcategoryMenuHovered]);

  const handleCategoryItemHover = useCallback((categoryId) => {
    setHoveredCategory(categoryId);
  }, []);

  const handleSubcategoryMenuHover = useCallback((isHovered) => {
    setIsSubcategoryMenuHovered(isHovered);
  }, []);

  const handleCategoryClick = useCallback((categoryId) => {



if(getWhich_is()===0 && ( categoryId===90 ||  categoryId===91 )   ){
handleExternalToggle();
setShowMenu(false);



}
else {
    setSelectedCategory(categoryId);
    setSelectedSubcategory('');
    setSearchKeyword('');
    setShowMenu(false);
    setShowImageDisplay(false);
    setSelectedProductId(null);
    setThumbnails([]);
    setHighResImage(null);
    fetchSubcategoriesByCategory(categoryId);

const targetDiv = document.getElementById('target-div1');
    if (targetDiv) {



      targetDiv.scrollIntoView({
        top: 100,
        behavior: 'smooth',
        block: 'start',
      });
    }



}











  }, [fetchSubcategoriesByCategory]);





  const handleCategoryClick2 = useCallback((categoryId) => {
if(getWhich_is()===1 && ( categoryId===90 ||  categoryId===91 )   ){
//setSelectedCategory(categoryId);
setSelectedCategoryIdd(  categoryId   );
setShowMenuC(false);
setShowMenuCC(true);

}
  }, [fetchSubcategoriesByCategory]);




















  const handleSubcategoryClick = useCallback((subcategoryId) => {
    setSelectedSubcategory(subcategoryId);
    setSelectedCategory('');
    setSearchKeyword('');
    setShowMenu(false);
    setShowImageDisplay(false);
    setSelectedProductId(null);
    setThumbnails([]);
    setHighResImage(null);



const targetDiv = document.getElementById('target-div1');
    if (targetDiv) {



      targetDiv.scrollIntoView({
        top: 100,
        behavior: 'smooth',
        block: 'start',
      });
    }












  }, []);

    
    
    const scrollToDivById = (id) => {
  const targetDiv = document.getElementById(id);
  if (targetDiv) {
    targetDiv.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
};

    
    
    
    
    
    
    
  const handleCloseImageDisplay = useCallback((e) => {
 
  
 

    
    e.preventDefault();
    setShowImageDisplay(false);
    setSelectedProductId(null);
    setThumbnails([]);
    setHighResImage(null);

 scrollToProductByKey(getSelectedProductIdd());








  }, []);


const [isMobile, setIsMobile] = useState(window.innerWidth <= 1068);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1068);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);



const styles1 = {
    imageDisplayRight: {
    width: '50%',
    paddingLeft: '10px',
    position: 'relative',
   transition: 'opacity 1.0s ease-in-out',

 display: isMobile ? 'none' : 'block', // Hide on mobile, show on larger screens


  },


imageDisplayLeft: {
    width:  isMobile ?'100%':      '50%',
    paddingRight: '10px',
    textAlign: 'center',
    position: 'relative',

    transition: 'opacity 1.0s ease-in-out',
  },


  squareLens: {
    position: 'absolute',
    width: '100px',
    height: '100px',
    backgroundColor: 'rgba(212, 163, 115, 0.3)',
    border: '1px solid #D4A373',
    clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
    pointerEvents: 'none',
    zIndex: 10,

display: isMobile ? 'none' : 'block', 


  },









  };













  return (


   <>
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-text">Loading...</div>
        </div>
      )}
   
 














    <div style={styles.container} ref={containerRef}>
      <h1 style={styles.storeName}>Mearcia Island</h1>
     
{whichIs === 0 && (
        <h2 style={styles.storeTitle}>Premier Grocery</h2>
      )}
      {whichIs === 1 && (
        <h2 style={styles.storeTitle}>Pizza & Grill</h2>
      )}


{whichIs === 1 && (
       <>
      <PromoImageSliderFeast />

      
   

</>


      )}















  <FeastBar ref={feastRef}         handleSectionClick={handleSectionClick}/>

   
   <div    style={styles.controls}>


       
 









 <div style={styles.leftGroup}>

        <input
          type="text"
          value={searchKeyword}
          onChange={handleSearchChange}
          placeholder="Search for a product"
          style={styles.searchInput}
        />
        <button
          type="button"
          onClick={handleMenuToggle}
          style={styles.browseButton}
        >
          {showMenu ? 'Close Menu' : 'Browse Products'}
        </button>

  <button
  type="button"
  onClick={
    
    
   // () => {
  //  setShowMenuC(true);
 //  fetchCategoriesBySet(1);

handleExternalToggle














   
  //}



}
  style={styles.browseButton}
>
  {getWhich_is() ? 'Premier Grocery' : 'Feast'}
</button>














</div>

 <div style={styles.rightGroup}>



<button style={styles.cartIconButton} onClick={toggleCartVisibility}>
              <div style={styles.cartIcon}>
                <svg
                  style={styles.cartIconSvg}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#3C2F2F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                  <path d="M3 6h18" />
                  <path d="M16 10a4 4 0 0 1-8 0" />
                </svg>
                {cart.length > 0 && (
                  <span style={styles.cartCount}>{cart.length}</span>
                )}
              </div>
              {showCart ? 'Hide Cart' : 'Show Cart'}
            </button>



</div>


      </div>
    





    




      <br></br>

{whichIs === 0 && (
       <>
      <PromoImageSlider />
<br></br>



      
      <PromoVideoSlider/>













  
</>


      )}













            



{showMenuC && (
  <div
    style={styles.overlay}
    onClick={() => setShowMenuC(false)} // optional: click outside to close
  >
    <div
      style={styles.menuContainerC}
      onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
    >
      <div
        ref={categoryMenuRef}
        style={styles.categoryMenu}
      >
        {categories.map((category) => (
          <div
            key={category.categoryId}
            style={{
              ...styles.menuItem,
              backgroundColor: hoveredCategory === category.categoryId ? '#E8D5B9' : '#FFF',
            }}
            onMouseEnter={() => setHoveredCategory(category.categoryId)}
            onMouseLeave={() => setHoveredCategory(null)}
            onClick={() => handleCategoryClick2(category.categoryId)}
          >
            {category.title}
          </div>
        ))}
      </div>
    </div>
  </div>
)}











{showMenuCC && (
  <div
    style={styles.overlay1}
    onClick={() => setShowMenuCC(false)} // optional: click outside to close
  >
   



<Feast/>












  </div>
)}



















   
      
      
















      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      {showMenu && (
        <div style={styles.menuContainer}
        
           onMouseLeave={() => setShowMenu(false)}
        >
          <div ref={setMenuRef} style={styles.setMenu}>
            {sets.map((set) => (
              <div
                key={set.setsId}
                ref={(el) => (setRefs.current[set.setsId] = el)}
                style={{
                  ...styles.menuItem,
                  backgroundColor: hoveredSet === set.setsId ? '#E8D5B9' : '#FFF',
                }}
                onMouseEnter={() => handleSetHover(set.setsId)}
              >
                {set.title}
              </div>
            ))}
          </div>
          {(hoveredSet || isCategoryMenuHovered) && categories.length > 0 && (
            <div
              ref={categoryMenuRef}
              style={{
                ...styles.categoryMenu,
                position: 'absolute',
                top: setRefs.current[hoveredSet] ? setRefs.current[hoveredSet].offsetTop : 0,
                left: setMenuRef.current ? (setMenuRef.current.offsetLeft + setMenuRef.current.offsetWidth) : 220,
              }}
              onMouseEnter={() => handleCategoryMenuHover(true)}
              onMouseLeave={() => handleCategoryMenuHover(false)}
            >
              {categories.map((category) => (
                <div
                  key={category.categoryId}
                  ref={(el) => (categoryRefs.current[category.categoryId] = el)}
                  style={{
                    ...styles.menuItem,
                    backgroundColor: hoveredCategory === category.categoryId ? '#E8D5B9' : '#FFF',
                  }}
                  onMouseEnter={() => handleCategoryItemHover(category.categoryId)}
                  onClick={() => handleCategoryClick(category.categoryId)}
                >
                  {category.title}
                </div>
              ))}
              {(hoveredCategory || isSubcategoryMenuHovered || subcategoriesLoading) && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: '100%',
                    width: '30px',
                    height: '100%',
                    backgroundColor: 'transparent',
                    zIndex: 1001,
                  }}
                  onMouseEnter={() => handleSubcategoryMenuHover(true)}
                />
              )}
            </div>
          )}
          {(hoveredCategory || isSubcategoryMenuHovered || subcategoriesLoading) && (
            <div
              style={{
                ...styles.subcategoryMenu,
                position: 'absolute',
                top: categoryRefs.current[hoveredCategory] ? categoryRefs.current[hoveredCategory].offsetTop : 0,
                left: categoryMenuRef.current ? (categoryMenuRef.current.offsetLeft + categoryMenuRef.current.offsetWidth) : 220,
                marginLeft: '-15px',
              }}
              onMouseEnter={() => handleSubcategoryMenuHover(true)}
              onMouseLeave={() => handleSubcategoryMenuHover(false)}
            >
              {subcategoriesLoading ? (
                <div style={styles.menuItem}>Loading subcategories...</div>
              ) : subcategories.length > 0 ? (
                subcategories.map((subcategory) => (
                  <div
                    key={subcategory.id}
                    style={{
                      ...styles.menuItem,
                      backgroundColor: '#FFF',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#E8D5B9')}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#FFF')}
                    onClick={() => handleSubcategoryClick(subcategory.id)}
                  >
                    {subcategory.name}
                  </div>
                ))
              ) : (
                <div style={styles.menuItem}>No subcategories available</div>
              )}
            </div>
          )}
        </div>
      )}




































      {showImageDisplay && (
       
        
        
        <div    id="target-div"                     style={styles.imageDisplay}>
          <button
            type="button"
            onClick={handleCloseImageDisplay}
            style={styles.closeButton}
            title="Close"
          >
            ×
          </button>



















          <div style={styles.imageDisplayLeft}>
            {imageLoading ? (
              <p style={{ ...styles.productDescription, textAlign: 'center' }}>Loading image...</p>
            ) : thumbnails.length === 0 || !highResImage ? (
              <div                >
                <img
                  src={PLACEHOLDER_IMAGE}
                  alt={`Product ${selectedProductId}`}
                  style={{
                    width: '100%',
                    maxWidth: '600px',
                    height: 'auto',
                    objectFit: 'contain',
                    borderRadius: '8px',
                  }}
                />
                <p style={{ ...styles.productDescription, marginTop: '5px' }}>
                  Image not available or unsupported format.
                </p>
              </div>
            ) : (
              <>
                <div        >
                  <img
                    ref={imageRef}
                    src={`data:${highResImage.imageType.toLowerCase()};base64,${highResImage.imageData}`}
                    alt={`Product ${selectedProductId}`}
                    style={{
                      width: '100%',
                      maxWidth: '600px',
                      height: 'auto',
                      objectFit: 'contain',
                      borderRadius: '8px',
                      marginBottom: '10px',
                    }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onMouseMove={handleMouseMove}

 




                  />
                  {isHovered && (
                    <div
                      style={{
                        ...styles.squareLens,
                        left: `${mousePos.x - 50}px`,
                        top: `${mousePos.y - 50}px`,
                      }}
                    />
                  )}
                </div>
                <div
                  style={{
                    display: 'flex',
                    gap: '10px',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                  }}
                >
                  {thumbnails.map((thumbnail) => (
                    <img
                      key={thumbnail.imageId}
                      src={`data:${thumbnail.imageType.toLowerCase()};base64,${thumbnail.imageData}`}
                      alt={`Thumbnail ${thumbnail.imageId}`}
                      style={{
                        width: '50px',
                        height: '50px',
                        objectFit: 'cover',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        border:
                          thumbnail.imageId === (highResImage && highResImage.imageId)
                            ? '2px solid #D4A373'
                            : '1px solid #E8D5B9',
                      }}
                      onClick={() => handleThumbnailClick(thumbnail.imageId)}
                    />
                  ))}
                </div>
              </>
            )}





 <button
                type="button"
                onClick={(e) => handleAddToCart(e, selectedProduct)}
                style={styles.addButton}
              >
                Add to Cart
              </button>








          </div>
          <div style={styles1.imageDisplayRight}>
            {isHovered && highResImage && (
              <div
                style={{
                  ...styles.zoomArea,
                  backgroundImage: `url(data:${highResImage.imageType.toLowerCase()};base64,${highResImage.imageData})`,
                  backgroundSize: `${imageRef.current ? imageRef.current.width * 2 : 600}px ${
                    imageRef.current ? imageRef.current.height * 2 : 400
                  }px`,
                  backgroundPosition: `-${
                    mousePos.x * 2 - (imageRef.current ? imageRef.current.width / 4 : 150)
                  }px -${
                    mousePos.y * 2 - (imageRef.current ? imageRef.current.height / 4 : 150)
                  }px`,
                }}
              />
            )}
          </div>
        </div>
      )}
      {loading && <p style={styles.productDescription}>Loading...</p>}
      {error && <p style={{ ...styles.productDescription, color: '#8B5E3C' }}>{error}</p>}
      <div   id="target-div1"               style={styles.productList}>
        {products.map((product) => (
          <div key={product.productId}  id={product.productId}      style={styles.productCard}>
            <div style={styles.productImageWrapper}          >
              <ProductImageDisplay
                productId={product.productId}
                fetchProductImage={fetchProductImage}
                onProductImageClick={     
                   handleProductImageClick               }
              />
            </div>
            <div style={styles.productDetailsWrapper}>
              <h3 style={styles.productName}>{product.name}</h3>
              <p style={styles.productDescription}>{product.description}</p>
              <p style={styles.productStock}>In Stock: {product.stock}</p>
              <p style={styles.productPrice}>Price: £{product.fullCost}</p>
              {product.promo_percentage > 0 && (
  <p style={styles.promoPercentage}>
    <span style={styles.discountBox}>{product.promo_percentage}% off  </span>  Limited time deal
  </p>
)}
              
              <button
                type="button"
                onClick={(e) => handleAddToCart(e, product)}
                style={styles.addButton}
              >
                Add to Cart
              </button>
            </div>
          </div>
        ))}
      </div>
      
      {showCart && (
        <div style={styles.cartDetails}       id="cart"      ref={cartRef}           >
          <h2 style={{ ...styles.productName, textAlign: 'left' }}>Cart</h2>
          {cart.length === 0 ? (
            <p style={styles.productDescription}>No items in cart</p>
          ) : (
            <>
              {cart.map((item) => (
                <div key={item.productId} style={styles.cartItem}>
                  <p style={styles.productDescription}>
                    {item.name} - £{item.fullCost}
                  </p>
                  <p style={styles.productDescription}>Quantity: {item.quantity}</p>
                  <div style={{ display: 'flex', gap: '5px' }}>
                    <button
                      type="button"
                      onClick={(e) => handleIncreaseQuantity(e, item.productId)}
                      style={styles.cartButton}
                    >
                      +
                    </button>
                    <button
                      type="button"
                      onClick={(e) => handleDecreaseQuantity(e, item.productId)}
                      style={styles.cartButton}
                    >
                      -
                    </button>
                    <button
                      type="button"
                      onClick={(e) => handleRemoveFromCart(e, item.productId)}
                      style={styles.cartButton}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}
              <p style={{ ...styles.productPrice, textAlign: 'right' }}>
                Total: £{calculateTotalBill()}
              </p>
            </>
          )}
          <button
            type="button"
            onClick={submitSale}
            style={styles.submitButton}
          >
            Submit Sale
          </button>
        </div>
      )}
    </div>


   </>






  );
};

export default ProductSearch;